// tw.js
export const locale = {
    GENERAL: {
        NAV_OPTIONS: ['首頁', '關於', '聯絡'],
        WELCOME_WORD: '歡迎來到 Vue 應用程式',
        OK: '確認',
        CONTINUE: '繼續',
        CANCEL: '取消',
        GUEST: '訪客',
    },
    language: {
      select: "LANGUAGE",
      tw: "Chinese",
      en: "English"
    },
    NAV_MENU:{
        NEWS: '最新消息',
        SOLUTION: '解決方案',
        ACTIVITY: '活動花絮',
        ABOUT_SMC: '關於中心',
        SAMPLE_CASE: '輔導案例',
        CONTACT: '聯絡我們',
    },
    NAV_SUB_MENU:{
        History: '中心沿革',
        Members: '中心成員',
        Achievements: '產學成果',
        _1F: '空間介紹一樓',
        _2F: '空間介紹二樓',
        Case_BDI: '泰國BDI集團',
        _Contact: '聯絡我們',
        Location: '交通位置',
    }
}


//////////////////
// WEBPACK FOOTER
// ./common/config/i18n/tw.js
// module id = null
// module chunks = 